<ngx-thank-you *ngIf="showThankYou$()" [cta]="ctaThankyou" [orderComplete]="orderComplete" [product]="productPurchased"></ngx-thank-you>
<div class="nav navbar container-fluid mat-elevation-z3 bg-smoke  d-flex justify-content-center">
    <mat-toolbar class="toolbar-sections-bar container d-flex flex-row gap-16 align-items-center justify-content-center bg-smoke">
        <!-- <ng-container *ngTemplateOutlet="tabButton; context: { tabindex: tabs.MY_SELFCARING, tablabel: 'my_selfcaring', tabicon: 'myselfcaring-icon'}" ></ng-container> -->
        <ng-container *ngTemplateOutlet="tabButton; context: { tabindex: tabs.ORDERS, tablabel: 'orders', tabicon: 'order-icon'}" ></ng-container>
        <ng-container *ngTemplateOutlet="tabButton; context: { tabindex: tabs.PROJECTS, tablabel: 'projects', tabicon: 'projects-icon'}" ></ng-container>
        <!-- <ng-container *ngIf="hasRelated$()">    
            <ng-container *ngTemplateOutlet="tabButton; context: { tabindex: tabs.OFFER, tablabel: 'offer', tabicon: 'offer-icon'}" ></ng-container>
        </ng-container> -->
        <!-- <ng-container *ngIf="hasBolletta$()">    
            <ng-container *ngTemplateOutlet="tabButton; context: { tabindex: tabs.INNOVATION_PROJECT, tablabel: 'innovation_project', tabicon: 'benchmark-icon'}" ></ng-container>
        </ng-container>     -->
        <button mat-button [matMenuTriggerFor]="menuTools"
        class="button-icon-suffix tab-button"
            [class.active]="itemSelectedIsATool$()" *ngIf="tools && tools.length > 0">Strumenti <span class="material-icons">arrow_drop_down</span></button> 
        <mat-menu #menuTools="matMenu">
            <span class="mat-menu-wrapper" (mouseleave)="closeMenu()">
                <ng-container *ngFor="let tool of tools;trackBy: trackByFn; let i = index" >
                    <button mat-menu-item (click)="SelectedTabIndexChange(i,tool.labelKey)" *ngIf="tool.visibilityCondition">{{tool.name | translate}}</button>
                </ng-container>
            </span>
        </mat-menu>
    </mat-toolbar>
</div>
<div class="page-content p--0">
    <div class="d-flex flex-column flex-lg-row  justify-content-lg-between gap-32">
        <div class="p--24">
            <app-page-title [pageTitle]=" pageTitle " [pageSubtitle]="pageSubtitle"
                *ngIf="pageTitle && pageTitle !== ''">
            </app-page-title>
        </div>
    </div>
</div>
<div class="container-expanded mb--32" [class.container-xs]="mobileQuery.matches">
    <div class="page-content">
        <div class="tab-item" id="tab0" *ngIf="currentTabIndex$() === tabs.MY_SELFCARING">Home</div>
        <div class="tab-item" id="tab1" *ngIf="currentTabIndex$() ===  tabs.ORDERS" [@fadeInLeft]>
            <app-section-orders (onAction)="orderAction($event)" [company]="company"></app-section-orders>
        </div>
        <div class="tab-item" id="tab2" *ngIf="currentTabIndex$() === tabs.PROJECTS" [@fadeInLeft]>
            <app-selfcaring-dashboard #selfcaringApp *ngIf="showSelfcaringDashboard && hasSelfcaring$()" [showOrders]="false" (onGetDashboardData)="handleSelfcaringEvent($event)"></app-selfcaring-dashboard>
            <app-promo-marketplace *ngIf="!hasSelfcaring$()" [title]="'Non hai progetti in corso'" [template]="'project'" [promo]="'promo.promo_selfcaring'"></app-promo-marketplace>
        </div>
        <!-- <div class="tab-item" id="tab3" *ngIf="currentTabIndex$() === tabs.OFFER" [@fadeInLeft]>
            <products-related *ngIf="hasRelated$()"></products-related>
        </div> -->
        <!-- <div class="tab-item" id="tab6" *ngIf="currentTabIndex$() === tabs.INNOVATION_PROJECT && hasBolletta$()" [@fadeInLeft] >
            <app-innovation-project *ngIf="hasBolletta$()"/>
        </div> -->
        <!-- <div class="tab-item" id="tab4" *ngIf="currentTabIndex$() === 4" [@fadeInLeft]>
            <app-tool-benchmark *ngIf="company" [company]="company"></app-tool-benchmark>
        </div>
        <div class="tab-item" id="tab5" *ngIf="currentTabIndex$() === 5" [@fadeInLeft]>
            <app-playmetrics-tool *ngIf="havePlaymetrics"></app-playmetrics-tool>
        </div> -->
        <!-- <div class="tab-item" id="tab7" *ngIf="currentTabIndex$() === 7" [@fadeInLeft]><app-assessment/></div> -->
        <ng-container *ngFor="let tool of tools;trackBy: trackByFn; let i = index">
            <div class="tab-item" id="tab{{tool.idx}}" *ngIf="currentTabIndex$() === (tool.idx) && tool.visibilityCondition" [@fadeInLeft]>
                <ng-container *ngIf="tool.module; else toolGeneric">
                    <ng-container *ngComponentOutlet="tool.module;inputs:tool.inputs"></ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #toolGeneric>
    Tool non disponibile
</ng-template>

<ng-template #tabButton let-tabindex="tabindex" let-tablabel="tablabel" let-tabicon="tabicon">
    <ng-container *ngIf="mobileQuery.matches">
        <button mat-icon-button color="primary" (click)="SelectedTabIndexChange(tabindex,tablabel)" [attr.aria-label]="tablabel" ><mat-icon [svgIcon]="tabicon"></mat-icon></button>
    </ng-container>
    <ng-container *ngIf="!mobileQuery.matches">
        <button mat-button [class.active]="currentTabIndex$() === tabindex" class="tab-button"
                (click)="SelectedTabIndexChange(tabindex,tablabel)">{{'page.selfcaring.tabs.' + tablabel | translate}}</button>
    </ng-container>
</ng-template>




<ng-template #noData>
    <p translate>{{ 'No available data' | translate }}</p>
</ng-template>